import { AccountingMigrationExternalSystem } from "@common/types/domains/accounting/accountingMigration";
import type { InstitutionKey } from "@design-system/InstitutionIcon/InstitutionIcon";

export interface ImportedAccountProvider {
    label: string;
    institution?: InstitutionKey;
}

const XERO: ImportedAccountProvider = { label: "Xero", institution: "xero" };
const QUICKBOOKS: ImportedAccountProvider = {
    label: "QuickBooks",
    institution: "quickbooks",
};
const IMPORTED: ImportedAccountProvider = { label: "Imported" };

export function getImportedAccountProvider(
    externalSystem?: AccountingMigrationExternalSystem | null,
): ImportedAccountProvider {
    switch (externalSystem) {
        case AccountingMigrationExternalSystem.XERO:
            return XERO;
        case AccountingMigrationExternalSystem.QUICKBOOKS_ONLINE:
        case AccountingMigrationExternalSystem.QUICKBOOKS_ONLINE_GL_COA:
        case AccountingMigrationExternalSystem.QUICKBOOKS_DESKTOP:
            return QUICKBOOKS;
        default:
            return IMPORTED;
    }
}
